import {
  CREATE_TEMPLATE,
  FETCH_TEMPLATE,
  FETCH_TEMPLATES_LIST,
  DELETE_TEMPLATE,
  FETCH_STATIC_TEMPLATE,
  UPDATE_TEMPLATE,
  TRIGGER_TEST_PREVIEW
} from "./types";
import * as templateApi from "@/api-client/template";
import { sortSearchPaginateActions } from "@/store/common/actions";

export default {
  async triggerTestPreview({ commit }, { data, onSuccess, onError }) {
    commit({
      type: TRIGGER_TEST_PREVIEW.request
    });

    try {
      const resp = await templateApi.triggerTestPreview(data);

      commit({
        type: TRIGGER_TEST_PREVIEW.success,
        payload: resp
      });

      onSuccess ? onSuccess(resp) : null;
    } catch (e) {
      commit({
        type: TRIGGER_TEST_PREVIEW.error,
        error: e.message
      });

      onError && onError(e);
    }
  },

  async fetchTemplatesList(
    { commit },
    { page, sort, page_size, search, queryString } = {}
  ) {
    commit({
      type: FETCH_TEMPLATES_LIST.request
    });

    try {
      const resp = await templateApi.fetchTemplatesList({
        sort,
        page,
        page_size,
        search,
        queryString
      });

      commit({
        type: FETCH_TEMPLATES_LIST.success,
        payload: resp
      });
    } catch (e) {
      commit({
        type: FETCH_TEMPLATES_LIST.error,
        error: e.message
      });
    }
  },

  async fetchTemplateById({ commit }, { id, onSuccess }) {
    commit({
      type: FETCH_TEMPLATE.request
    });

    try {
      const template = await templateApi.fetchTemplateById(id);
      commit({
        type: FETCH_TEMPLATE.success,
        payload: template
      });

      onSuccess ? onSuccess(template) : null;

      return template;
    } catch (e) {
      commit({
        type: FETCH_TEMPLATE.error,
        error: e.message
      });
    }
  },

  async createTemplate({ commit }, { data, onSuccess, onError }) {
    commit({
      type: CREATE_TEMPLATE.request
    });

    try {
      const template = await templateApi.createTemplate(data);
      commit({
        type: CREATE_TEMPLATE.success,
        payload: template
      });

      onSuccess ? onSuccess(template) : null;
    } catch (e) {
      commit({
        type: CREATE_TEMPLATE.error,
        error: e.errors
      });

      onError ? onError(e) : null;
    }
  },

  async deleteTemplate({ commit }, { id, onSuccess, onError }) {
    commit({
      type: DELETE_TEMPLATE.request
    });

    try {
      await templateApi.deleteTemplate(id);
      commit({
        type: DELETE_TEMPLATE.success,
        payload: id
      });

      onSuccess ? onSuccess() : null;
    } catch (e) {
      commit({
        type: DELETE_TEMPLATE.error,
        error: e.message
      });

      onError ? onError() : null;
    }
  },

  async fetchStaticPreview(
    { commit, rootState },
    { template, side, schema = "api", onSuccess, onError }
  ) {
    commit({ type: FETCH_STATIC_TEMPLATE.request });

    try {
      const staticHtml = await templateApi.fetchStaticTemplate(
        template,
        side,
        rootState.account.identity.account.id,
        schema
      );

      commit({
        type: FETCH_STATIC_TEMPLATE.success
      });

      onSuccess ? onSuccess(staticHtml) : null;

      return staticHtml;
    } catch (e) {
      commit({
        type: FETCH_STATIC_TEMPLATE.error,
        payload: e.message
      });

      onError ? onError(e.message) : null;
    }
  },

  async updateTemplate({ commit }, { id, data, onSuccess, onError } = {}) {
    try {
      commit({
        type: UPDATE_TEMPLATE.request
      });

      const resp = await templateApi.saveTemplate(id, data);

      commit({
        type: UPDATE_TEMPLATE.success,
        payload: resp
      });

      onSuccess && onSuccess();
    } catch (e) {
      commit({
        type: UPDATE_TEMPLATE.error,
        payload: e.message
      });

      onError && onError(e.message);
    }
  },

  ...sortSearchPaginateActions
};
